import React from 'react';
import { SortDirection } from '@src/types/common';
import { HiSortAscending, HiSortDescending } from 'react-icons/hi';

interface ColumnHeaderProps {
  title: string;
  columnKey: string;
  sortable?: boolean;
  sortOrder?: SortDirection | null;
  onSortChange?: (order: SortDirection | null) => void;
}

export const ColumnHeader: React.FC<ColumnHeaderProps> = ({
  title,
  sortable = false,
  sortOrder,
  onSortChange,
}) => {
  const handleSortClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!sortable || !onSortChange) return;

    let nextSort: SortDirection | null = null;
    switch (sortOrder) {
      case null:
        nextSort = 'ASC';
        break;
      case 'ASC':
        nextSort = 'DESC';
        break;
      case 'DESC':
        nextSort = null;
        break;
    }
    onSortChange(nextSort);
  };

  return (
    <div
      className='flex items-center justify-between !w-full'
      onClick={(e) => e.stopPropagation()}
    >
      <span
        className={`flex items-center gap-1 ${sortable ? 'cursor-pointer' : 'cursor-default'}`}
        onClick={sortable ? handleSortClick : undefined}
      >
        {sortable &&
          (sortOrder === 'ASC' ? (
            <HiSortAscending width={16} height={16} />
          ) : sortOrder === 'DESC' ? (
            <HiSortDescending width={16} height={16} />
          ) : (
            <HiSortAscending width={16} height={16} className='text-gray-400' />
          ))}
        {title}
      </span>
    </div>
  );
};
